class BaseRepository {
  // eslint-disable-next-line
  constructor() {

  }
}

export default BaseRepository;
